<template>
	<div class="bookingtable-component">
		<table class="table table-striped table-light table-hover">
			<thead class="thead-dark">
				<tr>
					<td>{{ $t('booking.roomstable.tableheader.roomnumber') }}</td>
					<td>{{ $t('booking.roomstable.tableheader.roomfloor') }}</td>
					<td>{{ $t('booking.roomstable.tableheader.roomfloorside') }}</td>
					<td>{{ $t('booking.roomstable.tableheader.beds') }}</td>
					<td>{{ $t('booking.roomstable.tableheader.roomcategory') }}</td>
					<td>&nbsp;</td>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(room, k) in this.$parent.allRooms" v-show="showRoomsTable">
					<td>
						<div v-if="!room.editing" @dblclick="editRoom(room)">{{ room.roomNumber }}</div>
						<div v-else="room.editing"><input type="text" @keyup.enter="endEditRoom(room)" v-model="room.roomNumber" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!room.editing" @dblclick="editRoom(room)">{{ room.floor }}</div>
						<div v-else="room.editing"><input type="text" @keyup.enter="endEditRoom(room)" v-model="room.floor" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!room.editing" @dblclick="editRoom(room)">{{ room.floorSide }}</div>
						<div v-else="room.editing"><input type="text" @keyup.enter="endEditRoom(room)" v-model="room.floorSide" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!room.editing" @dblclick="editRoom(room)">{{ room.beds }}</div>
						<div v-else="room.editing"><input type="text" @keyup.enter="endEditRoom(room)" v-model="room.beds" class="form-control"/></div>
					</td>
					<td>
						<div v-if="!room.editing" @dblclick="editRoom(room)">{{ room.roomCategory}}</div>
						<div v-else="room.editing">
							<select v-model="room.roomCategory" class="form-control">
								<option v-for="roomCategory in getAllRoomCategories()">{{roomCategory.code}} - {{roomCategory.description}}</option>
							</select>
						</div>
					</td>

					<td>
						<div v-if="!room.editing">
							<button @click="editRoom(room)" class="btn btn-secondary mr-2">{{ $t('booking.tablebuttons.edit') }}</button>
							<button @click="removeRoom(k, room)" class="btn btn-danger">{{ $t('booking.tablebuttons.delete') }}</button>
						</div>
						<div v-if="room.editing">
							<button @click="endEditRoom(room)" class="btn btn-success">{{ $t('booking.tablebuttons.ok') }}</button>
						</div>
					</td>
				</tr>
			</tbody>
<tfoot>
				<tr>
					<td><input type="text" v-model="roomNumber" class="form-control"/></td>
					<td><input type="text" v-model="floor" class="form-control"/></td>
					<td><input type="text" v-model="floorSide" class="form-control"/></td>
					<td><input type="text" v-model="beds" class="form-control"/></td>
					<td>
						<select v-model="roomCategory" class="form-control">
								<option v-for="roomCategory in getAllRoomCategories()">{{roomCategory.code}} - {{roomCategory.description}}</option>
							</select>
					</td>
					<td>
						<button @click="addRoom" class="btn btn-primary">{{ $t('booking.roomstable.tableheader.saveallrooms') }}</button>
					</td>
				</tr>
			</tfoot>
		</table>

		<div v-show="show_error_text">Bitte füllen Sie die Zimmerkategorie, Zimmer nummer und den KeyBoyCode aus!</div>

	</div>
</template>

<script>

	import axios from 'axios'
	import Stringify from 'vue-stringify'
	import DatePicker from 'vuejs-datepicker'
	import moment from 'moment'
	import { mapState } from 'vuex';

	export default {
		props: [],
		data: function () {
			return {
				showRoomsTable: true,
				show_error_text: false,
				lastItem: null,

				roomNumber: null,
				floor: null,
				floorSide: null,
				beds: null,
				roomCategory: null,
				editing: false
			}
	},
		computed: {
			...mapState('settings', ['config']),
		},
		mounted: function() {
			if( typeof this.$parent.allRooms !== 'undefined') {
			}
		},
		directives: {
			focus: {
				// directive definition
				inserted: function (el) {
					el.focus()
				}
			}
		},
		methods: {
			/** Edit Room entry **/
			editRoom(room) {
				if (this.lastItem) {
					this.lastItem.editing = false;
				}
				this.lastItem = room;
				room.editing = true;
			},
			endEditRoom(room) {
				room.editing = false;
				this.saveAllRooms();
			},

			saveAllRooms: function () {
				let formData = new FormData();
				let room = null;
				for (room in this.$parent.allRooms) {
					formData.append('allRooms[]', JSON.stringify(this.$parent.allRooms[room]));
				}

				axios({
					method: 'post',
					url: this.config.apiUrl + 'saveAllRooms',
          withCredentials: true,
					data: formData
				}).then(response => (this.$parent.getAllRooms()))
			},


			// Remove Room from Rooms Array
			removeRoom(k, room) {
				var isDelete = confirm("Sind Sie sicher (die Daten sind nach dem Löschen verloren) ?");
				if (isDelete) {
					let idx = this.$parent.allRooms.indexOf(room);
					this.$parent.allRooms.splice(idx, 1);

					let formData = new FormData();
					formData.append('roomToRemove', JSON.stringify(room));

					axios({
						method: 'post',
						url: this.config.apiUrl + 'removeRoom',
            withCredentials: true,
						data: formData
					}).then(response => (true))
				}
			},

			/** Add booking entry **/
			addRoom: function () {
				// console.log(this.$parent.allBookings);

				/*
				if(!this.roomcategory && !this.roomnumber && !this.keyBoyCode) {
					this.show_error_text = true;
					return false;
				} else {
					this.show_error_text = false;
				}
				*/

				let room = {
					id: 'new',
                    roomNumber: this.roomNumber,
					floor: this.floor,
					floorSide: this.floorSide,
					beds: this.beds,
					roomCategory: this.roomCategory,
					editing: false
				};
				this.$parent.allRooms.push(room);


				this.roomNumber = '';
				this.floor = '';
				this.bookingday = '';
				this.floorSide = '';
				this.beds = '';
				this.roomCategory = '';

				this.saveAllRooms();
			},

			/** getAllRoomCategories **/
			getAllRoomCategories: function() {
				return this.$parent.allRoomCategories;
			},
		},
		components: {
			DatePicker
		}
	}
</script>

<style scoped lang="scss">
	.bookingtable-component table td {
		cursor: pointer;
		vertical-align: middle;
	}

	.bookingtable-component table thead th,
	.bookingtable-component table tbody td:last-child,
  .bookingtable-component table tfoot td:last-child {
		white-space: nowrap;
    text-align: right;
	}

	.bookingtable-component table thead td {
		background-color: #383639;
		color: #fff;
		font-family: 'BrandonGrotesque-Bold';
		border-top: 1px solid #383639;
	}

	.bookingtable-component table tfoot td {
		background-color: #d5d5d6;
	}

	.bookingtable-component .btn {
		border-radius: 0;
	}
</style>

<style lang="scss">
	body {
		overflow: auto;
	}

	.bookingtable-component .form-control {
		font-size: 1rem;
		padding: .125rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		background: #fff;
		letter-spacing: 0;
	}

	.bookingtable-component .form-control:hover,
	.bookingtable-component .form-control:focus,
	.bookingtable-component .form-control:active {
		background: #fff;
	}
</style>
